<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRetirar="opcionRetirar" :opcionGestionar="opcionGestionar"  :requiereGestionar="requiereGestionar"
         :titulomodal="titulomodal" :botonmodal="botonmodal" :requiereBotongestionar="requiereBotongestionar"
         :condicionales="condicionales" :carpeta="carpeta" :datosExcel="datosExcel" :typeOrder="typeOrder" :perPage="perPage"></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            datosExcel:[],
            nombreEntidad: "entidad_solicitud",
            idVersion: 2,
            column: "id",
            typeOrder: "desc",
            perPage: 100,
            currentPage: 1,
             vista:"Histórico de solicitudes",
             proveniente:" - Histórico de solicitudes",
             carpeta:"Proveedores",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"en solicitud",
             editable:1,
             cliente:1,
             requiereGestionar:false,
             opcionRetirar:false,
             opcionGestionar:false,
             titulomodal:"Seguimiento",
             botonmodal:"Aceptar",
             requiereBotongestionar:"si",
             options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' }, { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'departamento', text: 'Departamento' },{ value: 'estado', text: 'Estado' }],
             
             departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsclientes: [
                { value: null, text: 'Seleccionar' },
                { value: 1, text: 'cliente1' },
                { value: 2, text: 'clientes2' }
            ],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            optionss: [
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                 { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },
            ],
            optionm:[{ value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },
             ],
            endDate: "",
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Solicitante', sortable: true }, 
                { key: 'F.Solicitud', sortable: true }, 
                { key: 'Asignó', sortable: true }, 
                { key: 'F.Asignación', sortable: true }, 
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                 { key: 'Paciente', sortable: true },
                 {key: 'Ciudad', sortable: true },
                 { key: 'Departamento', sortable: true },
                  { key: 'Estado', sortable: true },  'Acciones'],
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            condicionales: null,
            relaciones: [
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "tipo_documento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "Tipos_documento"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "medio_administracion",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "motivos_rechazo_proveedor"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "codigo_departamento" },
                        "columna_relacion_principal": "departamento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "divipola_colombia"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "estado",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "estados"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_proveedor",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_proveedor",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_cliente",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_cliente",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_prestador",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_prestador",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            ],
         }
 
     },
     computed: {
       
     },
     async created() {
        try 
        {

            const datosUser = localStorage.getItem('user');
            let datoUserJSON = JSON.parse(datosUser);
            let dato_proveedor = datoUserJSON.id_proveedor;
            if (dato_proveedor == null) {
                this.condicionales = {
                    "AND": [
                        {
                            "estado": {
                                "iLike": ""
                            }
                        }
                    ]
                };
            } else {
                this.condicionales = {
                    "AND": [
                        {
                            "estado": {
                                "iLike": ""
                            }
                        },
                        {
                            "id_proveedor": {
                                "equals": dato_proveedor
                            }
                        },
                    ]
                };
            }
           
            // La carga de datos la manejará el componente TableGeneral
            // No es necesario hacer la llamada aquí ya que se duplicaría
            
            } catch (error) {
                console.log(error)
            }
 
     },
     methods: {
      
     }
 };
 </script>
 <style>
 </style>
